var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[_c('router-link',{attrs:{"to":"/"}},[_c('YearBadge',{staticClass:"badge",attrs:{"collection":_vm.collection}})],1),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }